var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.618,2.31l-.023.023A7.218,7.218,0,0,1,0,0,7.166,7.166,0,0,0,.618,2.31Z",
    transform: "translate(2.392 19.868)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.553,2.777A2.777,2.777,0,1,1,2.777,0,2.777,2.777,0,0,1,5.553,2.777Z",
    transform: "translate(7.723 6.557)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M16.555,0H6.778C2.532,0,0,2.532,0,6.778v9.777a7.844,7.844,0,0,0,.653,3.313c1,2.217,3.15,3.465,6.125,3.465h9.777c4.247,0,6.778-2.532,6.778-6.778V6.778C23.333,2.532,20.8,0,16.555,0Zm4.877,12.25a2.6,2.6,0,0,0-3.29,0l-4.853,4.165a2.6,2.6,0,0,1-3.29,0l-.4-.327a2.591,2.591,0,0,0-3.08-.163L2.158,18.853a6.222,6.222,0,0,1-.408-2.3V6.778c0-3.29,1.738-5.028,5.028-5.028h9.777c3.29,0,5.028,1.738,5.028,5.028v5.6Z",
    transform: "translate(2.333 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.1e7a3b4e3bc43a7bb178e269d7b0209a.svg";
export { ForwardRef as ReactComponent };